// import { useTranslation } from '@klv/hooks/useTranslation';

import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/heroCenterSingleLineForm.module.scss';

import type { IHeroCenterSingleLineForm } from './types';
import { Wrapper } from '@klv/utils/wrapper';
import { SingleLineForm } from '@klv/atoms/single-line-form';
import type { TColorVariant } from '@klv/shared/styles/types';

export const HeroCenterSingleLineForm = ({
  className = '',
  backgroundColor = 'cotton',
  customPadding = { customPaddingBottom: 'md', customPaddingTop: 'md' },
  eyebrow,
  eyebrowTag = 'div',
  fadeIn = false,
  headline,
  headlineTag = 'h1',
  showSingleLineForm,
  singleLineSignUpWithWebsite,
  subhead,
  subheadTag = 'p',
}: IHeroCenterSingleLineForm) => {
  const formattedHeadline = headline ? headline.replace(/\n/g, '<br/>') : '';
  const formattedSubhead = subhead ? subhead.replace(/\n/g, '<br/>') : '';
  const formattedEyebrow = eyebrow ? eyebrow.replace(/\n/g, '<br/>') : '';
  const EyebrowTag = eyebrowTag || 'div';
  const HeadlineTag = headlineTag || 'h1';
  const SubheadTag = subheadTag || 'p';
  return (
    <Wrapper
      fadeIn={fadeIn ? .25 : 0}
      grid={true}
      backgroundColor={backgroundColor}
      customPadding={customPadding}
      contained={true}
      inlinePadding={true}
    >
    <div className={generateClassName([className, styles.heroCenterSingleLineFormTopSection])}>
      {eyebrow && (
          <EyebrowTag
            className={generateClassName([
              'eyebrow',
              'smPaddingTop',   
            ])}
            dangerouslySetInnerHTML={{ __html: formattedEyebrow }}
          />
      )}
      {headline && (
        <HeadlineTag
          className={generateClassName([
            'h1',
          ])} 
          dangerouslySetInnerHTML={{ __html: formattedHeadline}}
        />
      )}
      </div>
      <div className={styles.heroCenterSingleLineFormContentBottomSection}>
      {subhead && (
        <SubheadTag
          className={generateClassName([
            styles.subhead,
          ])} 
          dangerouslySetInnerHTML={{ __html: formattedSubhead }}
        />
      )}
      {showSingleLineForm && singleLineSignUpWithWebsite && (
          <SingleLineForm 
            gradientButton={singleLineSignUpWithWebsite.gradientButton}
            variant="companyWebsite"
            backgroundColor={backgroundColor as TColorVariant} 
            primaryButtonText={singleLineSignUpWithWebsite.buttonText} 
            placeholderText={singleLineSignUpWithWebsite.placeholderText} 
            redirectUrl={singleLineSignUpWithWebsite.redirectUrl}
          />
      )}
      </div>
    </Wrapper>
  );
};
